import React from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";
//import { formatoMexico } from "../../../../config/reuserFunction";
import { ConsultaContext } from "../Context";
import ImagenUniline from "../../../../images/unilineAzul.png";

export default function InfoConsulta() {
  moment.locale("es-mx");
  const { appointment } = React.useContext(ConsultaContext);
  const { hours, /* baseAmount, amount, */ fecha, hora, minuto } = appointment;

  if (!fecha) return null;

  const start = moment(fecha).hour(hora).minute(minuto);
  const end = moment(start).add(hours, "hours");
  return (
    <Box mt={1}>
      <Box display="flex" alignItems="center" height={100} py={1}>
        <img
          src={ImagenUniline}
          alt="logo-uniline"
          style={{ maxHeight: "100%", maxWidth: "100%" }}
        />
      </Box>
      <Typography variant="h6">
        <b>{`${appointment.summary} - ${appointment.product}`}</b>
      </Typography>
      <Typography variant="subtitle2">{`${appointment.name} - ${appointment.email}`}</Typography>
      <Typography variant="h6">{appointment.description}</Typography>
      <Typography>
        Horas: <b>{hours}</b>
      </Typography>
      <br />
      <Typography>
        {`Programar reunión para el dia ${moment(fecha).format(
          "LL"
        )} de ${moment(start).format("LT")} a ${moment(end).format(
          "LT"
        )} Hora México`}
      </Typography>
      <Typography>
        Al concretar pago se te enviara el enlace de la reunion
      </Typography>
      <br />
    </Box>
  );
}
